import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FaBookmark, FaRegBookmark, FaArrowLeft } from 'react-icons/fa';
import { getLocalStorageKey } from 'utils/utils';
import { getLocalStorageValue } from 'utils/utils';
import httpService from 'services/http-service';
import { useNavigate } from 'react-router-dom';

const SavedProfiles = () => {
  const [savedProfiles, setSavedProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchSavedProfiles = async () => {
    setLoading(true);
    try {
      const endpoint = '/User/GetAllSavedUsers';
      const response = await httpService('GET', endpoint);
      
      if (response && response?.succeeded) {
        const filteredProfiles = response?.data?.filter(profile => {
          if (!profile.savedUserHistories || profile?.savedUserHistories.length === 0) {
            return false;
          }
          const lastAction = profile?.savedUserHistories[profile?.savedUserHistories?.length - 1];
          return lastAction?.action === 'Inserted';
        });
        
        setSavedProfiles(filteredProfiles);
      } else {
        toast.error(response?.message || 'Failed to fetch saved profiles');
      }
    } catch (error) {
      console.error('Error fetching saved profiles:', error);
      toast.error('Failed to fetch saved profiles');
    } finally {
      setLoading(false);
    }
  };

 const handleSaveProfile = async (userId) => {
  const eventId = getLocalStorageKey('eventId');
  const currentUserId = getLocalStorageValue('userDetails', 'userId');
  
  const currentProfile = savedProfiles?.find(profile => profile?.userId === userId);
  const isCurrentlySaved = currentProfile?.isSavedUser ?? false;

  const saveData = {
    userId: userId,
    eventId: eventId,
    isSavedUser: !isCurrentlySaved 
  };

  setLoading(true);
  try {
    const endpoint = '/User/SavedUser';
    const response = await httpService('POST', endpoint, saveData);
    
    if (response && response?.succeeded) {
      toast.success(response?.message || 'Profile status updated');
      await fetchSavedProfiles(); 
    } else {
      toast.error(response?.message || 'Something went wrong');
    }
  } catch (error) {
    console.error('Error saving profile:', error);
    toast.error('Something went wrong');
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {
    fetchSavedProfiles();
  }, []);

  return (
    <div className="container mx-auto p-4">
      <div className="flex items-center mb-6">
        <button 
          onClick={() => navigate('/auth/events')}
          className="mr-4 rounded-full hover:bg-gray-100"
        >
          <FaArrowLeft className="text-gray-600 text-xl" />
        </button>
        <h1 className="text-2xl font-bold">Saved Profiles</h1>
      </div>
      
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <p>Loading...</p>
        </div>
      ) : savedProfiles?.length === 0 ? (
        <div className="text-center py-10">
          <p className="text-gray-500">No saved profiles found</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {savedProfiles?.map((profile) => {
            const shouldShowProfile = profile?.savedUserHistories && 
                                    profile?.savedUserHistories?.length > 0 &&
                                    profile?.savedUserHistories[profile?.savedUserHistories.length - 1].action === 'Inserted';
            
            if (!shouldShowProfile) return null;

            return (
              <div key={profile?.id} className="bg-white rounded-lg shadow-md overflow-hidden relative">
                <div className="h-48 bg-gray-200 flex items-center justify-center">
                  {profile?.userPhotoUrl ? (
                    <img
                      src={profile?.userPhotoUrl}
                      alt={profile?.userFullName}
                      className="h-full w-auto max-w-full object-contain"
                      onError={(e) => {
                        e.target.onerror = null;
                      }}
                    />
                  ) : (
                    <span className="text-gray-500">No Image Available</span>
                  )}
                </div>
                <button
                  onClick={() => handleSaveProfile(profile?.userId)}
                  className="absolute top-2 right-2 bg-white rounded-full p-2 shadow-md hover:bg-gray-100"
                >
                  <FaBookmark className={profile?.isSavedUser ? "text-black-600" : "text-gray-600"} />
                </button>
                
                <div className="p-4">
                  <h2 className="text-xl font-semibold">{profile?.userFullName}</h2>
                  <p className="text-gray-600">{profile?.eventName}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SavedProfiles;